import { initialize, pageview } from "react-ga";

class GoogleAnalytics {
  initialize = (trackingId) => initialize(trackingId);

  pageViewEvent = (path) => pageview(path);
}

export default new GoogleAnalytics();
